import { render, staticRenderFns } from "./HedefPotansiyelPlasiyer.vue?vue&type=template&id=2ed2f9ce&scoped=true"
import script from "./HedefPotansiyelPlasiyer.vue?vue&type=script&lang=js"
export * from "./HedefPotansiyelPlasiyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2f9ce",
  null
  
)

export default component.exports